import { instance } from '@app/api/axios';
import { useShowToaster } from '@shared/ui/messages/useToaster';
import { useDispatch } from 'react-redux';
import { fetchWithdrawChannels } from '@app/store/slices/withdrawChannelsSlice';

export function useChannel() {
  const showToaster = useShowToaster();
  const dispatch = useDispatch();

  const createChannel = async (data) => {
    try {
      const res = await instance.post('/teams/crypto_wallets/add', data);
      dispatch(fetchWithdrawChannels());
      showToaster('success', res?.data?.message);
      return true;
    } catch (err) {
      if (err?.response?.status !== 422) {
        showToaster('error', err?.response?.data?.message);
        return false;
      }
      throw err;
    }
  };

  const deleteChannel = async (data) => {
    try {
      const res = await instance.post(
        `/teams/crypto_wallets/delete/${data.id}`,
        {
          google2fa_code: data.google2fa_code,
        },
      );
      dispatch(fetchWithdrawChannels());
      showToaster('success', res?.data?.message);
      return true;
    } catch (err) {
      if (err?.response?.status !== 422) {
        showToaster('error', err?.response?.data?.message);
        return false;
      }
      throw err;
    }
  };

  const updateChannel = async (data) => {
    const { id, ...rest } = data;
    try {
      const res = await instance.post(`/teams/crypto_wallets/update/${id}`, {
        ...rest,
      });
      dispatch(fetchWithdrawChannels());
      showToaster('success', res?.data?.message);
      return true;
    } catch (err) {
      if (err?.response?.status !== 422) {
        showToaster('error', err?.response?.data?.message);
        return false;
      }
      throw err;
    }
  };

  return { createChannel, deleteChannel, updateChannel };
}
